export default "__VITE_ASSET__839111cd__"